import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import Stack from '@mui/material/Stack';
import { Box } from '@mui/system';
import dayjs from 'dayjs';
import _ from 'lodash';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import {
  RemoveWrapper,
  TitleWrapper,
  useTableStyles,
} from './styled-components';

import { RootState } from '../../../../../../utils/store';
interface InformedIndividualSectionProps {
  setIsRemove?: (isRemove: boolean) => void;
}

const InformedIndividualSection = ({
  setIsRemove: setIsRemoveCallback,
}: InformedIndividualSectionProps) => {
  const columns = [
    'Name',
    'Associated Department',
    'Notification Reason',
    'Date Informed',
  ];

  const departments = useSelector(
    (state: RootState) => state.reports.departments,
  );

  const finalReportItem = useSelector(
    (state: RootState) => state.finalReport.item,
  );

  //get default informed individual items
  const informedIndividualsItems = useSelector(
    (state: RootState) => state.informedIndividuals.items,
  );

  const [isRemove, setIsRemove] = useState<boolean>(false);
  const remove = () => {
    if (setIsRemoveCallback) setIsRemoveCallback(false);
    setIsRemove(true);
  };

  const tableWrapperClasses = useTableStyles();

  const getDepartmentName = (id: number): string => {
    let departmentName = '';
    const findDepartment = _.find(departments, (e) => e.value == id);
    if (typeof findDepartment != 'undefined')
      departmentName = findDepartment.label;

    return departmentName;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mb: 2,
      }}
    >
      {isRemove && (
        <Stack direction='row' sx={{ justifyContent: 'center' }}>
          <Box
            sx={{
              fontFamily: 'Schibsted Grotesk',
              fontSize: '14px',
              fontWeight: 400,
              color: '#F83B3B',
              fontStyle: 'italic',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <FormattedMessage defaultMessage='Informed Individuals has been removed.' />
          </Box>
          <Button
            onClick={() => {
              setIsRemove(false);
              if (setIsRemoveCallback) setIsRemoveCallback(true);
            }}
            sx={{
              backgroundColor: 'transparent !important',
              '&:hover': {
                backgroundColor: 'transparent !important',
              },
              '&:visited': {
                backgroundColor: 'transparent !important',
              },
              textTransform: 'none',
              pl: '16px',
              color: '#5D5D5D',
              fontFamily: 'Schibsted Grotesk',
              fontSize: '14px',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <FormattedMessage defaultMessage='Undo changes' />
          </Button>
        </Stack>
      )}
      {!isRemove && (
        <>
          <Stack direction='row' justifyContent='space-between'>
            <TitleWrapper>
              <FormattedMessage defaultMessage='Informed Individuals' />
            </TitleWrapper>
            {finalReportItem.status === 0 && (
              <RemoveWrapper onClick={remove}>
                <FormattedMessage defaultMessage='Remove' />
              </RemoveWrapper>
            )}
          </Stack>
          <Stack>
            <Table className={`${tableWrapperClasses.tableWrapper}`}>
              <TableHead>
                {columns.map((c, k) => (
                  <TableCell key={`tc-${k}`}>{c}</TableCell>
                ))}
              </TableHead>
              <TableBody>
                {(informedIndividualsItems.length === 0 ||
                  (!finalReportItem.has_informed_individuals &&
                    finalReportItem.status === 1)) && (
                  <TableRow>
                    <TableCell sx={{ textAlign: 'center' }} colSpan={4}>
                      <FormattedMessage defaultMessage='No informed individuals found.' />
                    </TableCell>
                  </TableRow>
                )}
                {((informedIndividualsItems.length > 0 &&
                  finalReportItem.has_informed_individuals &&
                  finalReportItem.status === 1) ||
                  (informedIndividualsItems.length > 0 &&
                    finalReportItem.status === 0)) &&
                  informedIndividualsItems.map((i, k) => (
                    <TableRow key={`tr-${k}`}>
                      <TableCell>
                        <div>{i.name}</div>
                      </TableCell>
                      <TableCell>
                        {getDepartmentName(i.associated_department)}
                      </TableCell>
                      <TableCell>
                        <div>{i.notification_reason}</div>
                      </TableCell>
                      <TableCell>
                        {dayjs(i.date_informed_at).format('LL')}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </Stack>
        </>
      )}
    </Box>
  );
};

export default InformedIndividualSection;
